import { render, staticRenderFns } from "./ArticleFileTab.vue?vue&type=template&id=456df0d6"
import script from "./ArticleFileTab.vue?vue&type=script&lang=js"
export * from "./ArticleFileTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports